export const philippineRegions = [
	{ value: "NCR", label: "NCR - National Capital Region" },
	{ value: "National Capital Region", label: "National Capital Region" },
	{ value: "CAR", label: "CAR - Cordillera Administrative Region" },
	{ value: "Region I", label: "Region I - Ilocos Region" },
	{ value: "Region II", label: "Region II - Cagayan Valley" },
	{ value: "Region III", label: "Region III - Central Luzon" },
	{ value: "Region IV-A", label: "Region IV-A - CALABARZON" },
	{ value: "Region IV-B", label: "Region IV-B - MIMAROPA" },
	{ value: "Region V", label: "Region V - Bicol Region" },
	{ value: "Region VI", label: "Region VI - Western Visayas" },
	{ value: "Region VII", label: "Region VII - Central Visayas" },
	{ value: "Central Visayas", label: "Central Visayas" },
	{ value: "Region VIII", label: "Region VIII - Eastern Visayas" },
	{ value: "Region IX", label: "Region IX - Zamboanga Peninsula" },
	{ value: "Region X", label: "Region X - Northern Mindanao" },
	{ value: "Region XI", label: "Region XI - Davao Region" },
	{ value: "Davao Region", label: "Davao Region" },
	{ value: "Region XII", label: "Region XII - SOCCSKSARGEN" },
	{ value: "Region XIII", label: "Region XIII - Caraga" },
	{ value: "BARMM", label: "BARMM - Bangsamoro Autonomous Region in Muslim Mindanao" },
];

export const philippineIslandGroups = [
	{ value: "Luzon", label: "Luzon" },
	{ value: "Visayas", label: "Visayas" },
	{ value: "Mindanao", label: "Mindanao" },
];

// Map regions to their island groups
export const regionToIslandGroup: Record<string, string> = {
	NCR: "Luzon",
	CAR: "Luzon",
	"Region I": "Luzon",
	"Region II": "Luzon",
	"Region III": "Luzon",
	"Region IV-A": "Luzon",
	"Region IV-B": "Luzon",
	"Region V": "Luzon",
	"Region VI": "Visayas",
	"Region VII": "Visayas",
	"Region VIII": "Visayas",
	"Region IX": "Mindanao",
	"Region X": "Mindanao",
	"Region XI": "Mindanao",
	"Region XII": "Mindanao",
	"Region XIII": "Mindanao",
	BARMM: "Mindanao",
};
